module.exports = __webpack_public_path__ + "static/media/modern-reader-3A.fbcce322.png";